












































































































































































import { Vue, Component } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import Uploader from '../components/NewUploader.vue';
import FormSearchInput from '../components/FormSearchInput.vue';
import { getAreas, save, getSchools, getType, getBaseInfo } from '../api';
import { Picker, Toast, Popup } from 'vant';
import qs from 'qs';

Vue.use(Picker).use(Popup);
@Component({
  components: {
    FormSearchInput,
    Uploader,
  },
})
export default class Apply extends Vue {
  addrcolor: boolean = false;
  typecolor: boolean = false;
  showPicker: boolean = false;
  placeholder: string = '请输入学校全称';
  title: string = '学校*';
  location: any[] = [];
  addr: any[] = [];
  columns: any[] = [];
  getSchools: any = getSchools;
  type: any[] = ['学民俗讲文化', '做年肴传亲情', '拜新年送祝福'];
  worksType: string = 'addr';
  addrText: string = '请选择区县';
  typeText: string = '请选择作品类型';
  name: string = '';
  age: string = '';
  teacher: string = '';
  school: string = '';
  work: string = '';
  introduction: string = '';
  img: any = [];
  vedio: any = [];
  typeId: number = 0;
  addrId: number = 0;
  num: number = 1;
  save: boolean = false;
  isvedio: boolean = false;
  food: string = '';
  condiment: string = '';
  workmanship: string = '';
  experience: string = '';
  //1705680000000; //2024-01-20 00:00:00
  //1708790399000; //2024-02-24 23:59:59
  intonowx: boolean = false;
  // 1705680000000 < new Date().getTime() &&
  // new Date().getTime() < 1708790399000;
  get config() {
    const conf = [];
    conf[0] = this.type;
    conf[1] = this.addr;
    return conf;
  }

  async created() {
    this.getLocation();
    // if (isWeiXin() && !window.localStorage.getItem('unionid')) {
    //   this.WechatLogin();
    // }
    if (window.udid) {
      this.AppLogin();
    } else {
      Toast('请在上游新闻APP内上传作品，操作流程请见“活动规则”。');
    }
    const res: any = getType();
    const ret = await getBaseInfo();
    const nowtimes = new Date().getTime();
    const endtime = ret.data.endTime * 1000;
    const starttime = ret.data.startTime * 1000;
    if (starttime < nowtimes && endtime > nowtimes) {
      this.intonowx = true;
    }
  }
  selectData(text: any) {
    this.school = text;
  }
  picker(index: number) {
    this.columns = this.config[index];
    this.showPicker = true;
    if (index === 0) {
      this.typecolor = true;
      this.worksType = 'type';
    } else {
      this.addrcolor = true;
      this.worksType = 'addr';
    }
  }
  onConfirm(value: any, index: any) {
    if (this.worksType === 'type') {
      const index1 = index === 1 ? 2 : index === 2 ? 1 : index;
      this.typeText = this.type[index];
      // if (index === 2) {
      //   this.num = 9;
      // } else {
      //   this.num = 1;
      // }
      this.typeId = index1 + 1;
      if (index === 1) {
        this.isvedio = true;
      } else {
        this.isvedio = false;
      }
    } else {
      this.addrText = value;
      this.addrId = index + 1;
    }
    this.showPicker = false;
  }
  onCancel() {
    this.showPicker = false;
  }
  beforeDestroy() {
    this.save = false;
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async getLocation() {
    const res: any = await getAreas();
    for (const i in res.data) {
      if (res.data[i]) {
        this.addr.push(res.data[i]);
      }
    }
  }
  upload() {
    if (!this.intonowx) {
      Toast('请于1月20日至2月24日上传作品');
      return false;
    }
    if (this.save) {
      Toast('上次提交还在请求中');
      return false;
    } else {
      this.save = true;
      setTimeout(() => {
        this.save = false;
      }, 3000);
      if (this.typeId === 1) {
        (this.$refs.uploader0 as Uploader).uploadToOss().then((res: any) => {
          this.img = res;
          (this.$refs.uploaderVideo0 as Uploader).uploadToOss().then((res1) => {
            this.vedio = res1;
            if (this.vedio.length > 0) {
              this.vedio = this.vedio[0];
              this.submit();
            } else {
              this.save = false;
            }
          });
          this.save = false;
        });
        this.save = false;
      } else if (this.typeId === 2) {
        (this.$refs.uploader2 as Uploader).uploadToOss().then((res: any) => {
          this.img = res;
          (this.$refs.uploaderVideo2 as Uploader).uploadToOss().then((res1) => {
            this.vedio = res1;
            if (this.vedio.length > 0) {
              this.vedio = this.vedio[0];
              this.submit();
            } else {
              this.save = false;
            }
          });
          this.save = false;
        });
        this.save = false;
      } else if (this.typeId === 3) {
        (this.$refs.uploader as Uploader).uploadToOss().then((res: any) => {
          this.img = res;
          if (this.img.length > 0 && this.isvedio) {
            (this.$refs.uploaderVideo as Uploader)
              .uploadToOss()
              .then((res1) => {
                this.vedio = res1;
                if (this.vedio.length > 0) {
                  this.vedio = this.vedio[0];
                  this.submit();
                } else {
                  this.save = false;
                }
              });
            this.save = false;
          } else {
            this.submit();
          }
        });
        this.save = false;
      } else {
        this.save = false;
      }
    }
  }
  submit() {
    const data = {
      name: this.name,
      class: this.age,
      teacher: this.teacher,
      title: this.work,
      school: this.school,
      introduction: this.introduction,
      work_type: this.typeId,
      county: this.addrId,
      countyname: this.addrText,
      cover: this.img.join('|'),
      udid: window.udid,
      appkey: window.appkey,
      video: this.vedio,
      food: this.food,
      condiment: this.condiment,
      workmanship: this.workmanship,
      experience: this.experience,
    };
    const noData =
      !this.name ||
      !this.age ||
      !this.work ||
      !this.school ||
      !this.teacher ||
      this.typeText === '请选择作品类型' ||
      this.addrText === '请选择区县' ||
      this.img.length === 0;
    const type2 =
      !this.food ||
      !this.condiment ||
      !this.workmanship ||
      !this.experience ||
      !this.vedio;
    if (noData || !this.vedio) {
      this.save = false;
      Toast('请输入必填项');
      return false;
    }
    if (this.isvedio) {
      if (type2) {
        this.save = false;
        Toast('请输入必填项');
        return false;
      }
    } else {
      if (!this.introduction) {
        this.save = false;
        Toast('请输入必填项');
        return false;
      }
    }
    // if (!/^[\u4e00-\u9fa5]+$/i.test(this.teacher)) {
    //   Toast('指导老师限一位');
    //   return false;
    // }
    save(data).then((res: any) => {
      if (res.code === 200) {
        // Toast('上传成功，请参加抽奖活动！');
        Toast('上传成功！');
        this.save = false;
        setTimeout(() => {
          this.$router.push('user');
        }, 1500);
      } else {
        this.save = false;
        Toast(res.msg);
      }
    });
  }
}
